/* gsk-reveal.js
   Sanftes Scroll-Reveal pro Element (Fade + leichtes Aufsteigen von unten),
   sobald ein Element in den Viewport kommt. Spiegelt das Frontend
   (golfsimulator.kaufen). Roman 2026-06-12: pro Element (Headline, Karten,
   Slider), nicht pro ganze Section.

   Fail-safe: ohne JS oder bei prefers-reduced-motion bleibt der Inhalt sichtbar
   (die Versteck-Regel haengt an der per JS gesetzten Klasse .gsk-reveal).
   Chrome (Hero/Header/Footer/WhatsApp) ist bewusst ausgenommen, damit Parallax,
   Laufschrift und der schwebende Button nicht doppelt animiert werden.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var UNIT = ['__head', '__card', '__tile', '__stat', '__logo', '__item', '__track', '__media', '__intro'];

  // Chrome (Hero/Header/Footer/WhatsApp/Mobile-Menue/Nav) per Teilstring ausnehmen,
  // weil die Section-Klassen einen Suffix tragen (z.B. gsk-hero-section, gsk-header-section).
  function inChrome(el) {
    return !!el.closest(
      '[class*="gsk-hero"],[class*="gsk-header"],[class*="gsk-foot"],[class*="gsk-whatsapp"],[class*="gsk-mobile"],[class*="gsk-nav"]'
    );
  }

  var sel = UNIT.map(function (s) {
    return 'section[class*="gsk-"] [class*="' + s + '"]';
  }).join(',');

  var nodes = Array.prototype.slice.call(document.querySelectorAll(sel));
  var counts = {};
  var seen = 0;
  var groups = [];

  function groupKey(parent) {
    var idx = groups.indexOf(parent);
    if (idx === -1) { groups.push(parent); idx = groups.length - 1; }
    return idx;
  }

  var units = [];
  nodes.forEach(function (el) {
    if (inChrome(el)) return;
    var track = el.closest('[class*="__track"]');
    if (track && track !== el) return; // Karten IM Track nicht einzeln, der Track ist die Einheit
    units.push(el);
  });

  units.forEach(function (el) {
    el.classList.add('gsk-reveal');
    var key = groupKey(el.parentElement);
    counts[key] = (counts[key] || 0);
    var delay = Math.min(counts[key] * 70, 350);
    counts[key] += 1;
    el.style.setProperty('--gsk-reveal-delay', delay + 'ms');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  units.forEach(function (el) { io.observe(el); });
})();
